import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import Loader, { LoaderType } from '@components/common/Loader/Loader';
import styles from './PopupLoader.module.scss';

// Portalled like the dialog: the island host element is `hidden`, so anything
// rendered in place would not show.
const PopupLoader: React.FC = () =>
  createPortal(
    <div
      className={classNames(styles.overlay, 'd-flex flex-ai-c flex-jc-c')}
      role='status'
      aria-live='polite'>
      <Loader
        type={LoaderType.FULL_PAGE}
        width={48}
        height={48}
      />
    </div>,
    document.body
  );

export default PopupLoader;
